/**
 * Returns a shallow copy of `object` with all of its undefined key values
 * removed. The returned TS type will also have the undefined keys omitted.
 *
 * @param object Subject object
 * @returns A shallow copy of `object` with undefined property values removed
 */
export const omitUndefinedEntries = <TObject extends {}>(object: TObject) =>
  Object.entries(object).reduce(
    (accumulator, [key, value]) =>
      value !== undefined ? { ...accumulator, [key]: value } : accumulator,
    {}
  ) as {
    [K in keyof TObject]: TObject[K] extends undefined ? never : TObject[K];
  };
